import UpdateBinderForm from 'components/features/update-binder-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function UpdateBinder() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('binder.binderRecords')}>
      <UpdateBinderForm />
    </HomeLayout>
  );
}

export default UpdateBinder;
